module.exports = __webpack_public_path__ + "static/img/icon_points_exchange.512d7487.png";